import React from "react";
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { TextField, DateField } from "components/Shared";
import { EmptyCard } from "components/Shared/EmptyCard";

function HistoryCards(props) {
    let notes = "";
    if (props.notes.length > 0) {
        notes = props.notes.map(({ id, dateCreated, description, note }) => (
            <Card key={id} className="md-block-centered">
                <CardContent>
                    <DateField field={dateCreated} styleClass="note-timestamp" includeTime={true} /><br />
                    <TextField field={description} styleClass="fieldText-bold" />
                    <TextField field={note} />
                </CardContent>
            </Card>
        ));
    } else {
        notes = EmptyCard();
    }
    return (<div className="details-notes">{notes}</div>);
}

HistoryCards.propTypes = {
    notes: PropTypes.array
};

export default HistoryCards;